export enum SearchScope {
  All = 'all',
  Filtered = 'filtered',
}
